import { type JSX } from "react";

import { Button, Kbd } from "./primitives";
import { IconShield, IconSparkle } from "./icons";

/** The first thing a user sees: calm, confident, unmistakably an intelligence OS — not a chatbot. */
export function Landing({ onEnter }: { onEnter: () => void }): JSX.Element {
  return (
    <main className="voss-landing">
      <div className="voss-landing__inner">
        <div className="voss-landing__mark" aria-hidden />
        <h1 className="voss-landing__title">
          Your personal
          <br />
          <em>intelligence operating system</em>
        </h1>
        <p className="voss-landing__sub">
          VOSS thinks with you across every part of your work — private by default, grounded in what it knows, and calm by design. You talk to VOSS. VOSS handles the rest.
        </p>
        <div className="voss-landing__row">
          <Button variant="primary" onClick={onEnter}>
            <IconSparkle width={16} height={16} /> Enter VOSS
          </Button>
          <span className="voss-landing__sub" style={{ fontSize: "var(--text-sm)" }}>
            or press <Kbd>Enter</Kbd>
          </span>
        </div>
        <div className="voss-landing__points">
          <span>
            <IconShield /> Local-first &amp; private
          </span>
          <span>Workspace-aware memory</span>
          <span>Answers you can verify</span>
        </div>
      </div>
    </main>
  );
}
